import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

interface ResetPasswordConfirmDialogProps {
  open: boolean;
  login: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export function ResetPasswordConfirmDialog({ open, login, onConfirm, onCancel }: ResetPasswordConfirmDialogProps) {
  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>Сброс пароля</DialogTitle>
      <DialogContent>
        <DialogContentText>{`Сгенерировать новый пароль для пользователя «${login}»? Текущий пароль перестанет действовать.`}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Отмена</Button>
        <Button color="warning" variant="contained" onClick={onConfirm}>
          Сбросить пароль
        </Button>
      </DialogActions>
    </Dialog>
  );
}
